import React, { Component } from 'react';
import { type RouteComponentProps } from 'react-router-dom';
import axios from 'axios';

interface userprops extends RouteComponentProps {}

interface user {
  username: string;
  email: string;
  password: string;
  errorMessage: string;
  user: any;
}

class Registration extends Component<userprops, user> {
  state: user = {
    username: 'sony.sadi',
    email: 'sony.sadi@gmail.com',
    password: '12345678',
    errorMessage: '',
    user: {},
  };

  render() {
    return (
      <div className="d-md-flex half">
        <div className="bg" style={{ backgroundImage: 'url("images/bg_1.jpg")' }}></div>
        <div className="contents">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="form-block mx-auto">
                  <div className="text-center mb-5">
                    <h5>Check your inbox/spam folder for confirmation email</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChange = (e: { target: { value: string | any } }, key: string) => {
    this.setState({ [key]: e.target.value } as any);
  };

  register = async (event: { preventDefault: () => void }) => {
    const that = this;
    event.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_API_SERVER}/auth/local/register`, {
        username: that.state.username,
        email: that.state.email,
        password: that.state.password,
      })
      .then((res: { data: { jwt: any; user: { confirmed: null } } }) => {
        this.setState({
          user: res.data,
        });
        if (res.data.jwt) {
          that.props.history.push('/dashboard');
        }
        if (res.data.user.confirmed == null) {
        }
      })
      .catch(
        (error: {
          response: {
            data: { message: Array<{ messages: Array<{ message: string }> }> };
          };
        }) => {
          if (error.response) {
            this.setState({
              errorMessage: error.response.data.message[0].messages[0].message
                .trim()
                .replace('Email', 'Email/Username'),
            });
          }
        },
      );
  };
}

export default Registration;
